module.exports = __webpack_public_path__ + "img/mainEventEnd_logo.9ab94192.png";